import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
  spaceXY: {
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  title: {
    fontSize: 22,
    lineHeight: 26,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
    marginTop: 70,
  },
  subtitle: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.GrayPallete.lightgrayThree,
    marginTop: 70,
  },
  description: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
  quest: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
    marginTop: 90,
    textAlign: 'center',
    maxWidth: 250,
    marginBottom: 10
  },
  containerButton: {marginTop: 20, width: '100%', alignItems: 'center'},
});
